<template>
  <div id="jcnav">
    <nav
      :class="classes"
      class="navbar navbar-expand-xl navbar-togglable fixed-top"
      style="background-color: rgba(0, 0, 0, 0.3);"
    >
      <!--<div class="container_"> -->
      <router-link
        v-popover:popover
        class="navbar-brand"
        to="/"
      >
        <img
          id="tplogo"
          src="img/transplus.png"
          height="40px"
          alt=""
          style="filter: brightness(0) invert(1);"
        >
      </router-link>
      <div class="ml-auto" />
      <div class="navbar-toggler">
        <slot v-bind="slotData" />
        <navbar-toggle-button
          :toggled="showMenu"
          @click.native.stop="toggle"
        />
      </div>  

      <div
        v-if="$slots['navbar-menu'] || $scopedSlots['navbar-menu']"
        id="navigation"
        v-click-outside="close"
        class="navbar-collapse"
        :style="menuImage ? `background: url(${menuImage}) 0% 0% / cover;` : ''"
        :class="[
          { show: showMenu },
          { 'has-image': menuImage },
          navMenuClasses
        ]"
        data-color="blue"
      >
        <!--<navbar-toggle-button :toggled="showMenu" @click.native.stop="toggle" style="padding:50px"></navbar-toggle-button>-->


        <slot name="before-menu" />
        <ul
          class="navbar-nav"
          :class="menuClasses"
        >
          <slot
            name="navbar-menu"
            v-bind="slotData"
          />
        </ul>
        <slot name="after-menu" />
      </div>
      <!--</div>-->
    </nav>
  </div>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import NavbarToggleButton from './NavbarToggleButton';
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();
      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

export default {
  name: 'Navbar',
  components: {
    CollapseTransition,
    NavbarToggleButton
  },
  props: {
    transparent: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'relative'
    },
    menuClasses: {
      type: [String, Object, Array]
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: 'white',
      validator(value) {
        return [
          'white',
          'default',
          'primary',
          'danger',
          'success',
          'warning',
          'info',
          'dark'          
        ].includes(value);
      }
    },
    navMenuClasses: {
      type: String,
      default: ''
    },
    menuImage: {
      type: String
    },
    expand: {
      type: [String, Boolean],
      default: 'lg'
    }
  },
  provide() {
    return {
      closeNavbar: this.close
    };
  },
  data() {
    return {
      showMenu: false,
      extraNavClasses: '',
      currentScrollValue: 0
    };
  },
  computed: {
    slotData() {
      return {
        toggle: this.toggle,
        open: this.open,
        close: this.close,
        isToggled: this.showMenu
      };
    },
    classes() {
      let color = `bg-${this.type}`;
      let navPosition = `navbar-${this.position}`;
      let colorOnScrollTransparent =
        this.colorOnScroll && this.currentScrollValue < this.colorOnScroll;

      if (this.position === 'fixed') {
        navPosition = 'fixed-top';
      }

      return [
        //{ 'navbar-transparent': this.transparent || colorOnScrollTransparent },
        //{ 'bg-dark': this.transparent || colorOnScrollTransparent },
        { [color]: !this.transparent && this.colorOnScroll === 0 },
        this.expand ? `navbar-expand-${this.expand}` : '',
        navPosition,
        this.extraNavClasses
      ];
    }
  },
  mounted() {
    document.addEventListener('scroll', this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.scrollListener);
  },
  methods: {
    setNav(value) {
      let htmlClasses = document.querySelector('html').classList;
      if (value) {
        htmlClasses.add('nav-open');
      } else {
        htmlClasses.remove('nav-open');
      }
      let isOpen = htmlClasses.contains('nav-open');
      let eventToTrigger = isOpen ? 'open' : 'close';
      this.showMenu = isOpen;
      this.$emit(eventToTrigger);
    },
    toggle() {
      this.setNav(!this.showMenu);
    },
    open() {
      this.setNav(true);
    },
    close() {
      if (this.showMenu) {
        this.setNav(false);
      }
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.currentScrollValue = scrollValue;
      console.log(this.colorOnScroll )
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `bg-${this.type}`;
        document.getElementById("tplogo").style.filter = "invert(0)"
        // document.getElementById("portal").style.color  = "white"
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = '';
          document.getElementById("tplogo").style.filter = "brightness(0) invert(1)"
          // document.getElementById("portal").style.color  = "white"
        }
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);       
    }
  }
};
</script>
<style>
.navbar{
    border-bottom: 1px solid rgba(255,255,255,0.5);
}
.navbar-toggler{
  margin-right:40px;
}
.container.custom-container {
  margin-left:0px;
  width:100%;
}

/*
.gradientTransition {
  background-image: linear-gradient(rgba(0,0,0,.5),rgba(0,0,0,.15),rgba(0,0,0,.05),rgba(0,0,0,0))
}
*/


</style>
